import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useTenant } from '../../contexts/TenantContext';
import { useErrorToast } from '../../components/common';
import { canAccessSurveyModule } from '../../constants/surveyAccessPermissions';

/**
 * Guards nested /survey child routes when the user lacks SDA permissions.
 */
export default function SurveyPermissionRoute({ permissions, children }) {
  const { hasPermission, loading, initialized } = useTenant();
  const { showErrorToast } = useErrorToast();

  const codes = Array.isArray(permissions) ? permissions : [permissions];
  const allowed = codes.some((code) => hasPermission(code));

  useEffect(() => {
    if (initialized && !loading && !allowed) {
      showErrorToast(`Access denied. Required permission: ${codes.join(' or ')}.`);
    }
  }, [initialized, loading, allowed, codes, showErrorToast]);

  if (!initialized || loading) {
    return null;
  }

  if (!canAccessSurveyModule(hasPermission)) {
    return <Navigate to="/" replace />;
  }

  if (!allowed) {
    return <Navigate to="/survey" replace />;
  }

  return children;
}
